const colors = {
  lightGrey: '#ecf0f1',
  lightGrey2: '#bdc3c7',
  shadowGrey: '#333333',
  darkBlue: '#2c3e50',
  darkBlue2: '#34495e'
}

export default colors;
